import React, { useState, useRef, useEffect } from "react";
import { connect } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import "./index.css";
import Footer from "../Flight/components/footer";
import Loader from "../Loader/Loader";
import MovieCarousel from "./components/MovieCarousel";
import MovieList from "./components/MovieList";
import AutoCompleteMovies from './AutoCompleteMovies'
import { Typography } from "@material-ui/core";
import MovieDetail from "./MovieDetail";

const useStyles = makeStyles((theme) => ({
  paper: {
    height: 140,
    width: 100,
  },
  control: {
    padding: "4%",
    [theme.breakpoints.down("sm")]: {
      padding: "4%",
    },
  },
  main: {
 marginTop:'20px',
    // [theme.breakpoints.down("sm")]: {
    //   paddingTop: "18%",
    // },
  },


  container: {
    backgroundColor: "var(--white)",
    borderRadius: 5,
  } 
}));

let data = [
  {
    Title: "The Lion King",
    Year: "2019",
    Runtime: "118 min",
    Poster:
      "https://m.media-amazon.com/images/M/MV5BMjIwMjE1Nzc4NV5BMl5BanBnXkFtZTgwNDg4OTA1NzM@._V1_SX300.jpg",
  },
  {
    Title: "Mowgli: Legend of the Jungle",
    Year: "2018",
    Runtime: "104 min",
    Poster:
      "https://m.media-amazon.com/images/M/MV5BMjMzODc2NzU5MV5BMl5BanBnXkFtZTgwNTMwMTE3NjM@._V1_SX300.jpg",
  },
  {
    Title: "Doctor Strange",
    Year: "2016",
    Runtime: "115 min",
    Poster:
      "https://m.media-amazon.com/images/M/MV5BNjgwNzAzNjk1Nl5BMl5BanBnXkFtZTgwMzQ2NjI1OTE@._V1_SX300.jpg",
  },
  {
    Title: "John Wick",
    Year: "2014",
    Runtime: "101 min",
    Poster:
      "https://m.media-amazon.com/images/M/MV5BMTU2NjA1ODgzMF5BMl5BanBnXkFtZTgwMTM2MTI4MjE@._V1_SX300.jpg",
  },
  {
    Title: "The Notebook",
    Year: "2004",
    Runtime: "123 min",
  },
];
function Hotels(props) {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);

  return (
    <>
 
      <div
        style={{ backgroundColor: "var(--darker)", color: "var(--darker)" }}
      >
        <div style={{paddingTop:'90px'}}> 
        <MovieDetail data={data[0]}/>
           <MovieCarousel/>
          <div className={`${classes.main} container`}>
          <div className="movie-search"> 
          <div className="movie-search-wrapper">
            <AutoCompleteMovies placeholder="Search for Movies, Shows, Events, Plays, Sports and activities"/>
          </div> 
          <div className="movie-menus">
            <ul>
              <li><Typography component="a">Movies</Typography></li>
              <li><Typography component="a">Stream</Typography></li>
              <li><Typography component="a">Events</Typography></li>
              <li><Typography component="a">Plays</Typography></li>
              <li><Typography component="a">Sports</Typography></li>
              <li><Typography component="a">Activities</Typography></li>
            </ul>
          </div>
          </div>

         <MovieList data={data} title="Recommended Movies"></MovieList>
          </div>
        </div>
        <div>
          <Footer />
        </div>
        <Loader show={loading} />
      </div>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    currency: state.flight.currency ? state.flight.currency : "",
    auth: state.user.auth,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    //   login: (creds) => dispatch(login(creds))
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Hotels);
